/*
 * @Description: 数字题校验
 * @Date: 2021-08-19 15:28:43
 */

import { Message } from 'element-ui';
import { formatDecimal, isMoney } from '@/tools/money';

const keys = ['minNum', 'maxNum']; // 最小、最大的key

export const minFor19 = -99999999;
export const maxFor19 = 99999999;

/**
 * @description: 输入实时校验
 * @param {string,object,string} input value, 当前item, 输入类型
 * @return {void} 校验失败后直接该值
 */
export const validate19Input = (value, example, inputKey) => {
  const { rule } = example;
  const { numberType } = rule;
  // 校验数字,input时第一位可输入【-】
  if (value === '-' || !isNaN(value)) {
    const splits = (value + '').split('.'); // 是否有小数
    const decimals = splits[1] || []; // 小数位数
    if (numberType) {
      if (decimals.length > 2) {
        Message({
          showClose: true,
          message: '只允许输入两位小数',
          type: 'error'
        });
        rule[inputKey] = formatDecimal(value, 2);
      }
    } else {
      if (splits.length > 1) {
        Message({
          showClose: true,
          message: '未勾选小数则不可填写小数',
          type: 'error'
        });
        rule[inputKey] = formatDecimal(value, 0);
      }
    }
    keys.forEach(item => {
      if (+rule[item] < minFor19 || +rule[item] > maxFor19) {
        Message({
          showClose: true,
          message: '请输入-99999999-99999999区间的数值',
          type: 'error'
        });
        rule[item] = '';
      }
    });
  } else {
    Message({
      showClose: true,
      message: '请输入正确数字',
      type: 'error'
    });
    rule[inputKey] = '';
    return;
  }
};
/**
 * @description: 最大值change后校验
 * @param {string,object} change value, 当前item
 * @return {void} 校验不成功直接改值
 */
export const validate19MaxChange = (val, example) => {
  const { rule } = example;
  const { minNum, maxNum, numberType } = rule;
  if (maxNum === '') return;
  if (!isMoney(maxNum)) {
    Message({
      showClose: true,
      message: '请输入正确数字',
      type: 'error'
    });
    rule.maxNum = '';
    return;
  }
  // 小于最小值置空
  if (maxNum !== '' && +maxNum <= +minNum) {
    Message({
      showClose: true,
      message: '【后面数字】需大于【前面数字】',
      type: 'error'
    });
    rule.maxNum = '';
    return;
  }
  rule.maxNum = formatDecimal(rule.maxNum, numberType ? 2 : 0);
};
/**
 * @description: 最小值change后校验
 * @param {string,object} change value, 当前item
 * @return {void} 校验不成功直接改值
 */
export const validate19MinChange = (val, example) => {
  const { rule } = example;
  const { minNum, maxNum, numberType } = rule;
  if (minNum === '') return;
  if (!isMoney(minNum)) {
    Message({
      showClose: true,
      message: '请输入正确数字',
      type: 'error'
    });
    rule.minNum = '';
    return;
  }
  if (maxNum !== '' && +minNum >= +maxNum) {
    Message({
      showClose: true,
      message: '【前面数字】需小于【后面数字】',
      type: 'error'
    });
    rule.minNum = '';
    return;
  }
  rule.minNum = formatDecimal(rule.minNum, numberType ? 2 : 0);
};
/**
 * @description: 差值判断，不符合则重置value
 * @param {object} 当前item
 * @return {object} {status,message} status:0校验失败,message校验信息
 */
export const validateDifferenceFor19 = example => {
  const { rule } = example;
  const { minNum, maxNum, numberType } = rule;
  // 整数差值为1
  if (+numberType === 0 && +maxNum - +minNum < 1) {
    rule.minNum = '';
    rule.maxNum = '';
    return {
      status: 0,
      message: '请输入差值为1的数值'
    };
  }
  return {
    status: 1,
    message: ''
  };
};
/**
 * @description: 保存校验
 * @param {object} 当前item
 * @return {object} 校验结果
 */
export const validateSaveDataFor19 = example => {
  const { rule } = example;
  const { minNum, maxNum } = rule;
  if (!minNum || !maxNum) {
    return {
      status: 0,
      message: '请输入数字范围限制'
    };
  }
  return validateDifferenceFor19(example);
};
export const setDefaultValueFor19 = (value, defaultValue) => {
  if (value === '' || isNaN(value)) {
    return defaultValue;
  }
  return value;
};
/**
 * @description: 切换是否展示小数
 * @param {string,object} change value, 当前item
 * @return {void} 修改后直接修改对应rule中的值
 */
export const changeBoxFor19 = (value, example) => {
  const { rule } = example;
  keys.forEach(item => {
    if (isMoney(rule[item])) {
      rule[item] = formatDecimal(rule[item], value ? 2 : 0);
    }
  });
};
